import React from 'react';
// @ts-ignore
import styles from 'DrMaxPharmacyListItem.module.scss';
import { joinClasses } from '../../../../Utils/className.util';
import Icon from '../../../BaseModule/Components/Layout/Icon/Icon';
import useTranslation from '../../../../Hooks/useTranslation';
import {
	DrMaxOpeningHour,
	DrMaxOpeningHourItem,
} from '../../../../graphql/graphql';
import InStock from '../InStock/InStock';

interface Props {
	item: Pharmacy;
	onItemSelect: (item: Pharmacy) => void;
}

export interface Pharmacy {
	id: string;
	name: string;
	isOpen: boolean;
	openingHours?: DrMaxOpeningHourItem[] | null;
	distanceFormatted?: string;
	inStock?: boolean;
}

const DrMaxPharmacyListItem: React.FC<Props> = ({ item, onItemSelect }) => {
	const { t } = useTranslation();

	return (
		<div className={styles.wrapper} onClick={() => onItemSelect(item)}>
			<div className={styles.content}>
				<div className={styles.title}>{item.name}</div>
				<div className={styles.bottom}>
					<div>
						<div
							className={joinClasses([
								styles.status,
								item.isOpen ? styles.open : styles.closed,
							])}
						>
							{item.isOpen
								? t('component.drmax.pharmacyOpen')
								: t('component.drmax.pharmacyClosed')}
						</div>
						{item?.inStock !== undefined && <InStock inStock={item.inStock} />}
					</div>
					<div className={styles.distanceContainer}>
						{item?.distanceFormatted && (
							<div className={styles.distance}>{item.distanceFormatted}</div>
						)}
					</div>
				</div>
			</div>
			<div className={styles.controls}>
				<div className={styles.arrow}>
					<Icon name={'fa-chevron-right'} />
				</div>
			</div>
		</div>
	);
};

export default DrMaxPharmacyListItem;
